import { WidgetTypes } from '../../typings';
import { LegacyQnrItemExtBase, IQnrItemExtParsedExt } from '../extension-base';

export class QuestionnaireItemMaxOccurs extends LegacyQnrItemExtBase {
  extensionUrl =
    'http://hl7.org/fhir/StructureDefinition/questionnaire-maxOccurs';
  supportedWidgets = [WidgetTypes.CheckboxWidget];
  constructor(config: Record<string, unknown> = {}) {
    super(config);
  }

  parse = (): IQnrItemExtParsedExt => {
    let maxSelected: number = null;
    if (this.extensionJson?.valueInteger) {
      maxSelected = this.extensionJson.valueInteger;
    }
    return {
      widgetProperties: {
        maxSelected,
      },
    };
  };
}

export function getItemMaxOccursExt(item: fhir4.QuestionnaireItem) {
  let extensionObj: QuestionnaireItemMaxOccurs;
  if (item?.extension) {
    // the FHIR resource is already validated at this point
    item.extension.forEach((extension) => {
      if (
        extension.url ===
        'http://hl7.org/fhir/StructureDefinition/questionnaire-maxOccurs'
      ) {
        extensionObj = new QuestionnaireItemMaxOccurs({
          extensionJson: extension,
        });
      }
    });
  }
  return extensionObj !== undefined
    ? extensionObj.parse().widgetProperties
    : {};
}
